export default __webpack_public_path__ + "static/media/Withdraw.5b77065f.svg";